<div class="modal fade modal--alert" id="cancel-alert-modal" tabindex="-1" role="dialog"aria-labelledby="cancel-alert-modal" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-alert">
        <div class="modal-alert__heading">
          <div class="container">
            <div class="modal-alert__avatar">
              <img src="assets/0/avatar/happy.png" class="img-fluid" alt="">
            </div>
            <button class="modal-alert__close" data-dismiss="modal">
              <svg class="icon">
                <use xlink:href="#close-medium"></use>
              </svg>
            </button>
          </div>
        </div>
    
        <div class="modal-alert__content">
          <div class="container">
            <div class="rte">
              <!-- <h4><span id="name"></span>, are you sure?</h4> -->
              <p>I would like to cancel <strong class="product_name">[Product Name]</strong>.</p>
            </div>
    
            <div class="modal-alert__content-btn">
              <a href="#" (click)="cancelConfirmed()"
                class="button button--lg button--primary remove-confirm order-last"
                data-dismiss="modal">Cancel</a>
              <a href="#" class="button button--lg button--secondary remove-dismiss" data-dismiss="modal">No,
                thanks</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

    <div class="modal fade modal--alert" id="cancel-confirm-modal" tabindex="-1" role="dialog"
      aria-labelledby="cancel-confirm-modal" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content modal-alert">
          <div class="modal-alert__heading">
            <div class="container">
              <div class="modal-alert__avatar">
                <img src="assets/0/avatar/happy.png" class="img-fluid" alt="">
              </div>
              <button class="modal-alert__close" data-dismiss="modal">
                <svg class="icon">
                  <use xlink:href="#close-medium"></use>
                </svg>
              </button>
            </div>
          </div>

          <div class="modal-alert__content">
            <div class="container">
              <div class="rte">
                <!-- <h4><span id="name"></span>, are you sure?</h4> -->
                <p>Your cancellation request has been sent to your Portfolio Manager and they will contact you
                  shortly to get further details to action your request.</p>
              </div>

              <div class="modal-alert__content-btn">
                <a href="#" class="button button--lg button--primary remove-dismiss" data-dismiss="modal">OK</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
